import { UserButton } from "@clerk/clerk-react";
import { NavLink, Outlet } from "react-router-dom";

const nav = [
  { to: "/", label: "Overview", end: true },
  { to: "/tenants", label: "Tenants" },
  { to: "/tenant-access", label: "Tenant access" },
  { to: "/users", label: "Users" },
  { to: "/partners", label: "Partners" },
  { to: "/integrations", label: "Integrations" },
];

export function AppShell() {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "240px 1fr",
        minHeight: "100%",
      }}
    >
      <aside
        style={{
          background: "var(--sd-surface)",
          borderRight: "1px solid var(--sd-border)",
          padding: "1.25rem 0",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ padding: "0 1.25rem 1.25rem", borderBottom: "1px solid var(--sd-border)" }}>
          <div style={{ fontWeight: 700, fontSize: "1.05rem", letterSpacing: "-0.03em" }}>SurgeDial</div>
          <div style={{ fontSize: "0.75rem", color: "var(--sd-muted)", marginTop: "0.25rem" }}>Platform admin</div>
        </div>
        <nav style={{ padding: "1rem 0.75rem", display: "flex", flexDirection: "column", gap: "0.25rem" }}>
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              style={({ isActive }) => ({
                padding: "0.55rem 0.75rem",
                borderRadius: "8px",
                fontSize: "0.9rem",
                fontWeight: 500,
                color: isActive ? "var(--sd-text)" : "var(--sd-muted)",
                background: isActive ? "var(--sd-accent-muted)" : "transparent",
                textDecoration: "none",
              })}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ marginTop: "auto", padding: "1rem 1.25rem", fontSize: "0.7rem", color: "var(--sd-muted)" }}>
          Staging shell — RBAC & data wiring in progress
        </div>
      </aside>
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>
        <header
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: "0.75rem 1.5rem",
            borderBottom: "1px solid var(--sd-border)",
            background: "var(--sd-bg)",
          }}
        >
          <UserButton afterSignOutUrl="/" />
        </header>
        <main style={{ padding: "1.75rem 2rem", flex: 1, overflow: "auto" }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
